const firebaseConfig = {
  apiKey: "AIzaSyD14NHcgvdQM2I-xqJ1RgDQQdNlRt6-ELg",
  authDomain: "nitya-leads.firebaseapp.com",
  projectId: "nitya-leads",
  storageBucket: "nitya-leads.firebasestorage.app",
  messagingSenderId: "727343965111",
  appId: "1:727343965111:web:8efa43378614758ed37e32",
  measurementId: "G-PTDE1GY0CM",
  allowBackgroundNotifications: true,
  allowForegroundNotifications: true,
};

const publicVapidKey =
  "BGMVu_gwI7Rd0WDYC97ehB594lsJ4_Bvzz791IvuEmDSndIpcnlY6KoUikeEUUNctrKHqd3cYrz8gdNI012cCOI";

const SW_FILENAME = "firebase-messaging-sw-v4.js";

export { firebaseConfig, publicVapidKey, SW_FILENAME };
